import React from "react";
import { Button, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { buildAttemptLabel, formatDate, formatTime, normalizeText, resolveActionLabel } from "./onboardingAlertsUtils";

const priorityClassNameByValue = {
  CRITICA: "is-critical",
  ALTA: "is-high",
  MEDIA: "is-medium",
  BAJA: "is-low",
};

export default function OnboardingAlertCard({ item, mobile = false, busy = false, onManage, onTake, onAssign, onRelease }) {
  const priorityKey = normalizeText(item.priority).toUpperCase();
  const priorityClassName = priorityClassNameByValue[priorityKey] || "is-neutral";
  const actionLabel = resolveActionLabel(item);
  const nextActionDate = formatDate(item.nextActionDate);
  const nextActionTime = formatTime(item.nextActionDate);

  const ownershipActions = [
    item.canTake ? { key: "take", label: "Tomar", handler: onTake } : null,
    item.canAssign ? { key: "assign", label: "Asignar", handler: onAssign } : null,
    item.canRelease ? { key: "release", label: "Liberar", handler: onRelease } : null,
  ].filter(Boolean);

  return (
    <article className={`onboarding-alert-card ${mobile ? "is-mobile" : ""}`}>
      <div className="onboarding-alert-card__commerce">
        <strong>{item.commerceName}</strong>
        <div className="onboarding-alert-card__meta">
          {item.cuit ? <span><b>CUIT:</b> {item.cuit}</span> : null}
          {item.terminal ? <span><b>Terminal:</b> {item.terminal}</span> : null}
          {item.commerceNumber ? <span><b>Comercio:</b> {item.commerceNumber}</span> : null}
          {item.province ? <span><b>Provincia:</b> {item.province}</span> : null}
        </div>
      </div>

      <div className="onboarding-alert-card__tracking">
        <span className="onboarding-alert-card__status-pill">{item.status}</span>
        <span className={`onboarding-alert-card__advance ${item.advanceActive.toLowerCase() === "activo" ? "is-active" : "is-inactive"}`}>
          {item.advanceActive.toLowerCase() === "activo" ? "Activo" : "Inactivo"}
        </span>
        <div className="onboarding-alert-card__detail-lines">
          {item.channel ? <span><b>Canal:</b> {item.channel}</span> : null}
          <span><b>Intento:</b> {buildAttemptLabel(item.currentAttempt, item.maxAttempts)}</span>
        </div>
      </div>

      <div className="onboarding-alert-card__next-action">
        {item.nextActionLabel ? <div className="onboarding-alert-card__next-title">{item.nextActionLabel}{item.channel ? ` por ${item.channel}` : ""}</div> : null}
        <div className="onboarding-alert-card__detail-lines">
          {nextActionDate ? <span><b>Fecha:</b> {nextActionDate}</span> : null}
          {nextActionTime ? <span><b>Horario:</b> {nextActionTime}</span> : null}
        </div>
      </div>

      <div className="onboarding-alert-card__priority">
        {item.priority ? <span className={`onboarding-alert-card__priority-pill ${priorityClassName}`}>{item.priority}</span> : <span className="onboarding-alert-card__empty">Sin prioridad</span>}
      </div>

      <div className="onboarding-alert-card__responsible">
        <span className={item.responsibleName ? "" : "is-empty"}>{item.responsibleName || "Sin responsable"}</span>
      </div>

      <div className="onboarding-alert-card__actions">
        <Button type="button" className="onboarding-alert-card__manage-btn" onClick={() => onManage?.(item.raw)} disabled={busy}>
          {actionLabel}
        </Button>
        {ownershipActions.length ? (
          <Dropdown align="end">
            <Dropdown.Toggle type="button" className="onboarding-alert-card__menu-btn" variant="light" disabled={busy} aria-label={`Más acciones para ${item.commerceName}`}>
              <FontAwesomeIcon icon={faEllipsisVertical} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {ownershipActions.map((action) => (
                <Dropdown.Item key={action.key} onClick={() => action.handler?.(item.raw)}>
                  {action.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : null}
      </div>
    </article>
  );
}
